import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Creators as MeasurementActions } from "../../../store/ducks/measurement";

import { Container, Footer } from "./styles";
import { Row, Col, Input, notification, Spin } from "antd";
import ButtonStandard from "../../utils/button";

import { save, findById, update } from "../../../services/measurementService";

const DrawerMeasurement = () => {
  const [form, setForm] = useState({
    name: null,
    code: null,
  });

  const [errors, setErrors] = useState([]);
  const [loadRequest, setLoadRequest] = useState(false);

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const { measurementId, isDrawerVisible } = useSelector(
    (state) => state.measurement
  );

  const dispatch = useDispatch();

  function resetDrawer() {
    setErrors([]);
    setForm({
      name: null,
      code: null,
    });
  }

  function closeDrawer() {
    resetDrawer();
    dispatch(MeasurementActions.showOrHideDrawer());
  }

  async function handleSubmitForm() {
    if (validateForm()) {
      const body = { ...form, status: "Active" };

      setLoadRequest(true);

      try {
        if (measurementId !== null) {
          await update({
            groupId,
            farmId,
            id: measurementId,
            body,
          });

          notification.success({
            message: "Medição atualizada com sucesso",
          });
        } else {
          await save({
            groupId,
            farmId,
            body,
          });

          notification.success({
            message: "Medição cadastrada com sucesso",
          });
        }

        dispatch(MeasurementActions.index(groupId, farmId));
        setLoadRequest(false);
        closeDrawer();
      } catch (error) {
        const backendMessage =
          error?.response?.data?.results?.message ||
          error?.response?.data?.message ||
          "";
        notification.error({
          message: backendMessage.toLowerCase().includes("code")
            ? "Atenção: Existe medições com esse código"
            : "Houve um erro ao salvar a medição",
        });
        setLoadRequest(false);
      }
    }
  }

  function validateForm() {
    let errorsList = [];

    if (form?.name === null || form.name.trim() === "") {
      errorsList.push("name");
    }
    if (form?.code === null || form.code.trim() === "") {
      errorsList.push("code");
    }

    setErrors(errorsList);
    return errorsList.length === 0;
  }

  async function handleDrawerVisible(visible) {
    if (visible) {
      if (measurementId !== null) {
        setLoadRequest(true);
        try {
          const {
            data: { results },
          } = await findById({
            groupId,
            farmId,
            id: measurementId,
          });
          if (results !== null) {
            setForm({
              name: results?.name,
              code: results?.code,
            });
          }
          setLoadRequest(false);
        } catch (error) {
          setLoadRequest(false);
        }
      }
    }
  }

  return (
    <Container
      title={
        measurementId === null
          ? translation.measurement.form.titleCreateNew
          : translation.measurement.form.titleEdit
      }
      width={700}
      onClose={closeDrawer}
      maskClosable={false}
      visible={isDrawerVisible}
      afterVisibleChange={handleDrawerVisible}
    >
      <div className="drawerForm">
        <Spin spinning={loadRequest}>
          {errors.length > 0 && (
            <Row type="flex" justify="center" align="middle">
              <label className="error">{translation.error.formError}</label>
            </Row>
          )}

          {/* Name */}
          <Row type="flex" className="rowLabel">
            <label className={errors.includes("name") ? "error" : ""}>
              {translation.measurement.form.name}*
            </label>
          </Row>
          <Row type="flex">
            <Col span={24}>
              <Input
                name="name"
                value={form?.name !== null ? form.name : ""}
                placeholder={translation.defaultPlaceholder}
                autoCapitalize="off"
                onChange={(e) => {
                  setForm({ ...form, name: e.target.value });
                }}
              />
            </Col>
          </Row>

          {/* Code */}
          <Row type="flex" className="rowLabel">
            <label className={errors.includes("code") ? "error" : ""}>
              {translation.measurement.form.code}*
            </label>
          </Row>
          <Row type="flex">
            <Col span={24}>
              <Input
                name="code"
                value={form?.code !== null ? form.code : ""}
                placeholder={translation.defaultPlaceholder}
                autoCapitalize="off"
                onChange={(e) => {
                  setForm({ ...form, code: e.target.value });
                }}
              />
            </Col>
          </Row>
        </Spin>
      </div>
      <Footer>
        <Row type="flex">
          <Col span={24} className="buttonsDiv">
            <ButtonStandard
              type="button"
              buttonType="type7"
              onClick={closeDrawer}
            >
              {translation.buttons.cancel}
            </ButtonStandard>

            <ButtonStandard
              type="button"
              buttonType="type6"
              onClick={handleSubmitForm}
            >
              {translation.buttons.save}
            </ButtonStandard>
          </Col>
        </Row>
      </Footer>
    </Container>
  );
};

export default DrawerMeasurement;
